const language = JSON.parse(sessionStorage.getItem("language"));
export let changedLang;

export const languageFunc = (lang) => {
  sessionStorage.getItem("language") && language?.flag === "ar"
    ? (changedLang = lang?.arabicLang)
    : (changedLang = lang?.engLang);
};
